import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Search } from "../../components";
import { services } from "../../data";

const LookingFor = () => {
  const [filteredServices, setFilteredServices] = useState(services);

  const handleSearch = (e) => {
    setFilteredServices(e);
  };
  return (
    <div className="bg-white flex w-full justify-center">
      <div className="flex flex-col items-center gap-6 max-w-screen-xl pt-[60px] pb-[80px] px-5 xl:px-0">
        <p className="text-5xl text-center mb-3">
          Explore other comprehensive service options to find the perfect
          solution for your places.
        </p>
        <div className="w-5/6 md:w-3/5 mb-5">
          <Search
            data={services}
            onSearch={handleSearch}
            placeholder="What are you looking for.."
          />
        </div>

        <div className="w-full flex flex-wrap justify-between md:justify-evenly gap-6">
          {filteredServices.map((service, index) => (
            <NavLink
              className="flex h-[60px] w-[46%] items-center justify-center shadow-lg cursor-pointer md:w-[31%] bg-lightblue-2 hover:bg-lightblue-3 text-xl transition-all duration-150 px-2 text-center"
              key={index}
              to={`/services/${service.id}`}
            >
              <p className="text-blue-6 text-md md:text-lg">{service.name}</p>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LookingFor;
